import React from "react";
import TopSection from "./TopSection";

const HeaderSection = () => {
  return (
    <div className="w-full">
      {/* TopBar */}
        {/* <TopSection/> */}
      {/* Below TopBar Layout */}
      <div className="w-full flex justify-between items-center px-6 py-4 bg-white">
        {/* Left Side */}
        <div className="flex space-x-6">
          {/* First Section - Satyamev Jayate Image */}
          <div className="flex items-center">
            <img
              src="/satyamev-jayate.jpg" // replace with actual image path
              alt="Satyamev Jayate"
              className="w-16 h-16 object-contain"
            />
          </div>

          {/* Second Section - Name of Government */}
          <div className="flex flex-col justify-center">
            <span className="text-lg font-semibold">महाराष्ट्र शासन | ग्रामपंचायत चांडोली खुर्द ता.आंबेगाव जि.पुणे</span>
            <span className="text-sm text-gray-600">Government of Maharashtra</span>
          </div>
        </div>

        {/* Right Side */}
        <div className="flex items-center">
          <img
            src="/maha-gov-logo.png" // replace with actual image path
            alt="Satyamev Jayate"
            className="w-16 h-16 object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
